"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StartDataFeedT = exports.StartDataFeed = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const data_feed_config_js_1 = require("../../solarxr-protocol/data-feed/data-feed-config.js");
/**
 * Requests for the other party to send `data_feeds`.
 * For example, GUI requests for position data to be sent from server.
 *
 * When sending a new `StartFeed`, the old data feeds should stop being sent.
 * We still support multiple data feeds at the same time, because `data_feeds`
 * is a list.
 *
 * Multiple data feeds are useful to get data at different frequencies.
 */
class StartDataFeed {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsStartDataFeed(bb, obj) {
        return (obj || new StartDataFeed()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsStartDataFeed(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new StartDataFeed()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    dataFeeds(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? (obj || new data_feed_config_js_1.DataFeedConfig()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    dataFeedsLength() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    static startStartDataFeed(builder) {
        builder.startObject(1);
    }
    static addDataFeeds(builder, dataFeedsOffset) {
        builder.addFieldOffset(0, dataFeedsOffset, 0);
    }
    static createDataFeedsVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startDataFeedsVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static endStartDataFeed(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createStartDataFeed(builder, dataFeedsOffset) {
        StartDataFeed.startStartDataFeed(builder);
        StartDataFeed.addDataFeeds(builder, dataFeedsOffset);
        return StartDataFeed.endStartDataFeed(builder);
    }
    unpack() {
        return new StartDataFeedT(this.bb.createObjList(this.dataFeeds.bind(this), this.dataFeedsLength()));
    }
    unpackTo(_o) {
        _o.dataFeeds = this.bb.createObjList(this.dataFeeds.bind(this), this.dataFeedsLength());
    }
}
exports.StartDataFeed = StartDataFeed;
class StartDataFeedT {
    constructor(dataFeeds = []) {
        this.dataFeeds = dataFeeds;
    }
    pack(builder) {
        const dataFeeds = StartDataFeed.createDataFeedsVector(builder, builder.createObjectOffsetList(this.dataFeeds));
        return StartDataFeed.createStartDataFeed(builder, dataFeeds);
    }
}
exports.StartDataFeedT = StartDataFeedT;
